export const isMobileDevice = () => {
  return window.matchMedia('(max-width: 767.98px)').matches
}